import React from 'react';
import EmployeeSettingsOptionV2 from './employee.index.v2';
import EmployeeSettingsOptionV3 from './employee.index.v3';

const EmployeeSettingsOption = () => {
    const isNewLogin = process.env.REACT_APP_USE_NEW_LOGIN === 'true' || process.env.REACT_APP_USE_NEW_LOGIN === 'TRUE';
    if (isNewLogin) return <EmployeeSettingsOptionV3 />;
    return <EmployeeSettingsOptionV2 />;
};

export default EmployeeSettingsOption;
